/* eslint-disable no-template-curly-in-string */
/* Copyright (c) 2020-present CloudIO Inc */

import { ComponentSample, Item, TriggerItemType } from 'componentregistry';
import { triggerNames } from './TriggersManager';

const page: {
  root: Item<'Page'>;
  triggerOnPortraitScreen: Item<'TriggerOnPortraitScreen'>;
  flexPanel: Item<'FlexPanel'>;
  flexItem: Item<'FlexItem'>;
  box: Item<'Box'>;
  typography: Item<'Typography'>;
  setData: Item<'ActionSetData'>;
  setData1: Item<'ActionSetData'>;
  triggerOnLandscapeScreen: Item<'TriggerOnLandscapeScreen'>;
  typography1: Item<'Typography'>;
  triggerOnWindowSizeChange: Item<'TriggerOnWindowSizeChange'>;
  setData2: Item<'ActionSetData'>;
  typography2: Item<'Typography'>;
  triggerOnExtraLargeScreen: Item<'TriggerOnExtraLargeScreen'>;
  setData3: Item<'ActionSetData'>;
  triggerOnExtraSmallScreen: Item<'TriggerOnExtraSmallScreen'>;
  setData4: Item<'ActionSetData'>;
  setData5: Item<'ActionSetData'>;
  triggerOnMediumScreen: Item<'TriggerOnMediumScreen'>;
  setData6: Item<'ActionSetData'>;
  triggerOnLargeScreen: Item<'TriggerOnLargeScreen'>;
  triggerOnSmallScreen: Item<'TriggerOnSmallScreen'>;
  setData7: Item<'ActionSetData'>;
} = {
  box: {
    children: ['typography', 'typography1', 'typography2'],
    itemId: 'box',
    parent: 'flexItem',
    props: {
      boxHeight: '1',
      flexDirection: 'column',
    },
    type: 'Box',
  },
  flexItem: {
    children: ['box'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem'],
    itemId: 'flexPanel',
    parent: 'root',
    props: {},
    type: 'FlexPanel',
  },
  root: {
    children: [
      'triggerOnExtraLargeScreen',
      'triggerOnExtraSmallScreen',
      'triggerOnLandscapeScreen',
      'triggerOnLargeScreen',
      'triggerOnMediumScreen',
      'triggerOnPortraitScreen',
      'triggerOnSmallScreen',
      'triggerOnWindowSizeChange',
      'flexPanel',
    ],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'Responsive Trigger',
      },
    },
    type: 'Page',
  },
  setData: {
    children: [],
    itemId: 'setData',
    parent: 'triggerOnPortraitScreen',
    props: {
      key: { type: 'text', value: 'message' },
      value: {
        type: 'text',
        value: 'Portrait',
      },
    },
    type: 'ActionSetData',
  },
  setData1: {
    children: [],
    itemId: 'setData1',
    parent: 'triggerOnLandscapeScreen',
    props: {
      key: { type: 'text', value: 'message' },
      value: {
        type: 'text',
        value: 'Landscape',
      },
    },
    type: 'ActionSetData',
  },
  setData2: {
    children: [],
    itemId: 'setData2',
    parent: 'triggerOnWindowSizeChange',
    props: {
      key: { type: 'text', value: 'size' },
      value: {
        type: 'expression',
        value: '`${$.screen.width} x ${$.screen.height}`',
      },
    },
    type: 'ActionSetData',
  },
  setData3: {
    children: [],
    itemId: 'setData3',
    parent: 'triggerOnExtraLargeScreen',
    props: {
      key: { type: 'text', value: 'device' },
      value: {
        type: 'text',
        value: 'Extra Large',
      },
    },
    type: 'ActionSetData',
  },
  setData4: {
    children: [],
    itemId: 'setData4',
    parent: 'triggerOnExtraSmallScreen',
    props: {
      key: { type: 'text', value: 'device' },
      value: {
        type: 'text',
        value: 'Extra Small',
      },
    },
    type: 'ActionSetData',
  },
  setData5: {
    children: [],
    itemId: 'setData5',
    parent: 'triggerOnMediumScreen',
    props: {
      key: { type: 'text', value: 'device' },
      value: {
        type: 'text',
        value: 'Medium',
      },
    },
    type: 'ActionSetData',
  },
  setData6: {
    children: [],
    itemId: 'setData6',
    parent: 'triggerOnLargeScreen',
    props: {
      key: { type: 'text', value: 'device' },
      value: {
        type: 'text',
        value: 'Large',
      },
    },
    type: 'ActionSetData',
  },
  setData7: {
    children: [],
    itemId: 'setData7',
    parent: 'triggerOnSmallScreen',
    props: {
      key: { type: 'text', value: 'device' },
      value: {
        type: 'text',
        value: 'Small',
      },
    },
    type: 'ActionSetData',
  },
  triggerOnExtraLargeScreen: {
    children: ['setData3'],
    itemId: 'triggerOnExtraLargeScreen',
    parent: 'root',
    props: {},
    type: 'TriggerOnExtraLargeScreen',
  },
  triggerOnExtraSmallScreen: {
    children: ['setData4'],
    itemId: 'triggerOnExtraSmallScreen',
    parent: 'root',
    props: {},
    type: 'TriggerOnExtraSmallScreen',
  },
  triggerOnLandscapeScreen: {
    children: ['setData1'],
    itemId: 'triggerOnLandscapeScreen',
    parent: 'root',
    props: {},
    type: 'TriggerOnLandscapeScreen',
  },
  triggerOnLargeScreen: {
    children: ['setData6'],
    itemId: 'triggerOnLargeScreen',
    parent: 'root',
    props: {},
    type: 'TriggerOnLargeScreen',
  },
  triggerOnMediumScreen: {
    children: ['setData5'],
    itemId: 'triggerOnMediumScreen',
    parent: 'root',
    props: {},
    type: 'TriggerOnMediumScreen',
  },
  triggerOnPortraitScreen: {
    children: ['setData'],
    itemId: 'triggerOnPortraitScreen',
    parent: 'root',
    props: {},
    type: 'TriggerOnPortraitScreen',
  },
  triggerOnSmallScreen: {
    children: ['setData7'],
    itemId: 'triggerOnSmallScreen',
    parent: 'root',
    props: {},
    type: 'TriggerOnSmallScreen',
  },
  triggerOnWindowSizeChange: {
    children: ['setData2'],
    itemId: 'triggerOnWindowSizeChange',
    parent: 'root',
    props: {},
    type: 'TriggerOnWindowSizeChange',
  },
  typography: {
    children: [],
    itemId: 'typography',
    parent: 'box',
    props: {
      text: {
        type: 'expression',
        value: '$.$pageData.message',
      },
      variant: 'h2',
    },
    type: 'Typography',
  },
  typography1: {
    children: [],
    itemId: 'typography1',
    parent: 'box',
    props: {
      text: {
        type: 'expression',
        value: '$.$pageData.size',
      },
      variant: 'h5',
    },
    type: 'Typography',
  },
  typography2: {
    children: [],
    itemId: 'typography2',
    parent: 'box',
    props: {
      text: {
        type: 'expression',
        value: '$.$pageData.device',
      },
      variant: 'h3',
    },
    type: 'Typography',
  },
};

export const responsiveTriggersHelpRenders = <K extends TriggerItemType>(
  type: K,
): ComponentSample<K>[] => [
  {
    title: triggerNames[type],
    page,
    exampleId: type,
    clearParentChildren: false,
    height: 380,
    visibleProps: [],
    hideProps: true,
    item: {
      // @ts-ignore - type
      type: 'TriggerOnWindowSizeChange',
      props: {} as any,
      itemId: 'triggerOnWindowSizeChange',
      parent: 'root',
      children: ['setData2'],
    },
  },
];
